module.exports = __webpack_public_path__ + "img/logo-retail.0476d760.png";